import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
 
 
 
 
export default function ProtestoQuod({
  protestos
}: {
  protestos: any
}) {
  const { t } = useTranslation();
  
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {protestos && protestos.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta, pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('protestosSP')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestosSP')}</span>)} </div>;
  }
 
    return (
    <Panel headerTemplate={headerTemplate}> 
      {protestos.length === 0 ? ( <NadaConsta />) : (    
       <DataTable size="small" value={protestos} tableStyle={{ minWidth: '50rem' }}>
          <Column field="cartorio" header={t('cartorio')}></Column>
          <Column field="endereco" header={t('endereco')}></Column>
          <Column field="cidade" header={t('cidade')}></Column>
          <Column field="uf" header={t('uf')}></Column>
          <Column field="telefone" header={t('telefone')}></Column>
          <Column field="quantidade" header={t('quantidade')}></Column>
          <Column field="valor" header={t('valor')}></Column>
      </DataTable>)}
    </Panel>
  )
}